var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hasLinks
    ? _c("div", [_c("span", [_vm._v("No content available.")])])
    : _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "d-flex justify-content-end mt-3",
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btnFilter_2 mr-2",
                      on: { click: _vm.newMandate },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-plus" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "fab-label" }, [
                        _vm._v(_vm._s(_vm.$t("mandate.new_mandate"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "export-wrapper mr-2" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter_2",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.showExportModal = !_vm.showExportModal
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa-light fa-upload" }),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("mandate.export")) +
                              "\n          "
                          ),
                          _c("i", {
                            staticClass: "fa-light ml-2",
                            class: _vm.showExportModal
                              ? "fa-chevron-up"
                              : "fa-chevron-down",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.showExportModal
                        ? _c("div", { staticClass: "export-menu" }, [
                            _c(
                              "button",
                              {
                                staticClass: "export-menu-item",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.chooseExport("csv")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-file-csv mr-2",
                                }),
                                _vm._v("\n            CSV\n          "),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "export-menu-item",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.chooseExport("pdf")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-file-pdf mr-2",
                                }),
                                _vm._v("\n            PDF\n          "),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "btnFilter_2 mr-2",
                      on: {
                        click: function ($event) {
                          _vm.displayFilter = !_vm.displayFilter
                        },
                      },
                    },
                    [
                      _vm.displayFilter
                        ? _c("i", { staticClass: "fa-light fa-minus" })
                        : _c("i", { staticClass: "fa-light fa-plus" }),
                      _vm._v(
                        "\n      " + _vm._s(_vm.$t("filter.fltr")) + "\n    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "btnFilter_2",
                      on: { click: _vm.onRefresh },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-rotate-right" }),
                      _vm._v(
                        "\n      " + _vm._s(_vm.$t("common.rfrsh")) + "\n    "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr", { staticClass: "mx-auto" }),
          _vm._v(" "),
          _vm.displayFilter
            ? _c(
                "b-row",
                {
                  staticClass:
                    "min-w-100 justify-content-start align-items-center",
                },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("mandate.dbtr_name_1")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.dbtr_name,
                          expression: "dbtr_name",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "filter-item-content w-100",
                      staticStyle: { padding: "0.35rem 0.5rem 0.35rem 0.7rem" },
                      domProps: { value: _vm.dbtr_name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.dbtr_name = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("mandate.dbtr_iban_1")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.dbtr_iban,
                          expression: "dbtr_iban",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "filter-item-content w-100",
                      staticStyle: { padding: "0.35rem 0.5rem 0.35rem 0.7rem" },
                      domProps: { value: _vm.dbtr_iban },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.dbtr_iban = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("mandate.canal_creation")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.canal_creation,
                            expression: "canal_creation",
                          },
                        ],
                        staticClass: "filter-item-content w-100",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.canal_creation = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("──────────"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: 2 } }, [
                          _vm._v("GUI"),
                        ]),
                        _vm._v(" "),
                        _c("option", { domProps: { value: 3 } }, [
                          _vm._v("API"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("mandate.schema")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.scheme,
                            expression: "scheme",
                          },
                        ],
                        staticClass: "filter-item-content w-100",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.scheme = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("──────────"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "CORE" } }, [
                          _vm._v("CORE"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "B2B" } }, [
                          _vm._v("B2B"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("mandate.unique_mandate_rf")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.idFilter,
                          expression: "idFilter",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "filter-item-content w-100",
                      staticStyle: { padding: "0.35rem 0.5rem 0.35rem 0.7rem" },
                      attrs: {
                        placeholder: "e.g. FR12ZZZ000000000123456-2025-00001",
                      },
                      domProps: { value: _vm.idFilter },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.idFilter = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c(
                      "span",
                      { staticClass: "filter-item-title d-block mb-1" },
                      [_vm._v(_vm._s(_vm.$t("mandate.status_collection")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.statusFilter,
                            expression: "statusFilter",
                          },
                        ],
                        staticClass: "filter-item-content w-100",
                        staticStyle: { padding: "0.35rem" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.statusFilter = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "All" } }, [
                          _vm._v("──────────"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.statuses, function (s) {
                          return _c(
                            "option",
                            { key: s, domProps: { value: s } },
                            [_vm._v(_vm._s(s))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "span",
                        { staticClass: "filter-item-title d-block mb-1" },
                        [_vm._v(_vm._s(_vm.$t("Webheader.date_begin")))]
                      ),
                      _vm._v(" "),
                      _c("datetime-picker-custom", {
                        class: {
                          "filter-item-input": true,
                          "filter-item-input-complete": _vm.dateBeginFilter,
                        },
                        staticStyle: { padding: "0.35rem" },
                        attrs: {
                          format: "YYYY-MM-DD",
                          periodFull: "",
                          id: "filter-datebegin",
                          customInputParentClass: "filter-item-content",
                          customInputClass: "w-100",
                          maxLength: 19,
                          placeholderValue: _vm.$t(
                            "common.datepicker_format_date3"
                          ),
                          inputIcon: "fa-solid fa-calendar",
                        },
                        model: {
                          value: _vm.dateBeginFilter,
                          callback: function ($$v) {
                            _vm.dateBeginFilter = $$v
                          },
                          expression: "dateBeginFilter",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "3" } },
                    [
                      _c(
                        "span",
                        { staticClass: "filter-item-title d-block mb-1" },
                        [_vm._v(_vm._s(_vm.$t("Webheader.date_end")))]
                      ),
                      _vm._v(" "),
                      _c("datetime-picker-custom", {
                        class: {
                          "filter-item-input": true,
                          "filter-item-input-complete": _vm.dateEndFilter,
                        },
                        staticStyle: { padding: "0.35rem" },
                        attrs: {
                          format: "YYYY-MM-DD",
                          periodFull: "",
                          id: "filter-dateend",
                          customInputParentClass: "filter-item-content",
                          customInputClass: "w-100",
                          maxLength: 19,
                          placeholderValue: _vm.$t(
                            "common.datepicker_format_date3"
                          ),
                          inputIcon: "fa-solid fa-calendar",
                        },
                        model: {
                          value: _vm.dateEndFilter,
                          callback: function ($$v) {
                            _vm.dateEndFilter = $$v
                          },
                          expression: "dateEndFilter",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end mt-3",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter_2 mr-2",
                          attrs: { disabled: !_vm.hasInputFilter },
                          on: { click: _vm.clearFilterFields },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.rst")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btnFilter_2",
                          on: { click: _vm.applyFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.srch")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.displayFilter
            ? _c("hr", { staticClass: "mx-auto mb-4" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "mx-auto mb-4", attrs: { cols: "12" } },
                [
                  _c(
                    "div",
                    { staticStyle: { overflow: "auto" } },
                    [
                      _vm.activateSpinner
                        ? _c("spinner")
                        : _vm.filteredMandates.length > 0
                        ? _c("b-table", {
                            key: _vm.refreshKey,
                            staticClass:
                              "table table-striped table-clickable-no-hover",
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              striped: "",
                              responsive: "",
                              items: _vm.mandates,
                              fields: _vm.fields,
                              "primary-key": "id",
                              "tbody-tr-class": function () {
                                return "table-row-clickable"
                              },
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDir,
                            },
                            on: {
                              "row-clicked": _vm.onRowClick,
                              "update:sortBy": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "update:sort-desc": function ($event) {
                                _vm.sortDir = $event
                              },
                              "head-clicked": _vm.sortTable,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(status)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        class: [
                                          "chip",
                                          "chip--" +
                                            _vm.statusVariant(data.value),
                                        ],
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "mandate.status_mandate_" +
                                                data.value
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(actions)",
                                fn: function (ref) {
                                  var item = ref.item
                                  return [
                                    _c(
                                      "b-link",
                                      {
                                        staticClass: "text-decoration-none",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.onRowClick(item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("mandate.view_details")
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          })
                        : _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c("span", { staticClass: "noResult" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("common.no_result")) +
                                    "\n          "
                                ),
                              ]),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-5" },
            [
              _c(
                "b-col",
                [
                  _c("cm-pagination", {
                    attrs: {
                      maxResultsByPage: _vm.paginationObject.maxResults,
                      firstIndex: _vm.paginationObject.firstIndex,
                      nbResultsTotal: _vm.paginationObject.nbResultsTotal,
                      refreshEvent: _vm.paginationObject.refresh,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }